/* unplugin-vue-components disabled */import { render } from "./comp1Hebei.vue?vue&type=template&id=2f7e649c&scoped=true"
import script from "./comp1Hebei.vue?vue&type=script&lang=js"
export * from "./comp1Hebei.vue?vue&type=script&lang=js"

import "./comp1Hebei.vue?vue&type=style&index=0&id=2f7e649c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7e649c"]])

export default __exports__